const productStatus = {
  RECEIVED: 'Received',
  INPROGRESS: 'In Progress',
  LISTING_DONE: 'Listing Done',
  IN_TRANSPORT: 'In Transport',
  COMPLETE: 'Complete',
};

const productStatusLabels = [
  { value: productStatus.RECEIVED, label: productStatus.RECEIVED },
  { value: productStatus.INPROGRESS, label: productStatus.INPROGRESS },
  { value: productStatus.LISTING_DONE, label: productStatus.LISTING_DONE },
  { value: productStatus.IN_TRANSPORT, label: productStatus.IN_TRANSPORT },
  { value: productStatus.COMPLETE, label: productStatus.COMPLETE },
];
/**
 * It takes a string or an array of strings and returns an array of objects
 * @param processingStatus - The processing status of the product.
 * @returns An array of objects.
 */
const processingStatusFilterCalculate = (processingStatus) => {
  if (!processingStatus) return [];
  if (Array.isArray(processingStatus)) {
    return processingStatus.map((aProcessingStatus) =>
      productStatusLabels.find(
        (productStatusLabel) => productStatusLabel.value === aProcessingStatus
      )
    );
  }
  return [
    productStatusLabels.find((productStatusLabel) => productStatusLabel.value === processingStatus),
  ];
};

module.exports = {
  productStatus,
  productStatusLabels,
  processingStatusFilterCalculate,
};
